/* eslint-disable no-unused-vars */
import * as React from "react";
/* eslint-enable no-unused-vars */
import { connect } from "react-redux";
import { IApplicationState } from "../../models/store/storeTypes";
import * as storeEffects from "../../models/store/storeEffects";
import { ICalendarTaskPageOwnProps, ICalendarTaskPageStateProps, ICalendarTaskPageDispatchProps, CalendarTaskPage } from "../../components/calendarTask/CalendarTaskPage";
import { ITypedOption } from "../../models/common/typedOption";
import { CalendarTaskThunkDispatch, getCalendarTaskPage } from "source/models/store/calendarTask";

export function mapStateToProps(applicationState: IApplicationState, ownProps: ICalendarTaskPageOwnProps): ICalendarTaskPageStateProps {
    if (!applicationState || !applicationState.front) {
        return {
            appState: null,
            dataId: -1,
            calendarTaskPage: null
        };
    }
    const calendarTask = applicationState.calendarTask;
    return {
        appState: applicationState.session,
        dataId: calendarTask.page.dataId,
        calendarTaskPage: calendarTask.page.calendarTaskPage
    };
}

export function mapDispatchToProps(dispatch: CalendarTaskThunkDispatch): ICalendarTaskPageDispatchProps {
    return {
        onGetCalendarTasksPage: () => dispatch(getCalendarTaskPage()),
        onLogout: () => dispatch(storeEffects.logout()),
        onSetCulture: (culture: string) => dispatch(storeEffects.setCulture(culture)),
        onSaveUserParameters: (parameters: ITypedOption[]) => dispatch(storeEffects.saveUserParameters(parameters)),
        onRefreshSessionState: () => dispatch(storeEffects.refreshSessionState()),
    };
}

export default connect<ICalendarTaskPageStateProps, ICalendarTaskPageDispatchProps, ICalendarTaskPageOwnProps>(mapStateToProps, mapDispatchToProps)(CalendarTaskPage);